import { Columns2 } from 'lucide-react';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';

type Props = {
  renderSideBySide: boolean;
  onToggle: () => void;
};

export const DiffViewToggle = ({ renderSideBySide, onToggle }: Props) => {
  const nextViewLabel = renderSideBySide
    ? 'Switch to inline view'
    : 'Switch to side by side view';

  return (
    <Button className="justify-end" onClick={onToggle} variant="ghost">
      <span className="text-muted-foreground">{nextViewLabel}</span>
      <Columns2
        className={cn(
          'transition-all duration-200 ease-in',
          renderSideBySide && 'rotate-90'
        )}
      />
    </Button>
  );
};
